import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./NavBar.css";

function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [appsDropdownOpen, setAppsDropdownOpen] = useState(false);
  const [blogDropdownOpen, setBlogDropdownOpen] = useState(false);
  const appsDropdownRef = useRef(null);
  const blogDropdownRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 24);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (appsDropdownRef.current && !appsDropdownRef.current.contains(event.target)) {
        setAppsDropdownOpen(false);
      }
      if (blogDropdownRef.current && !blogDropdownRef.current.contains(event.target)) {
        setBlogDropdownOpen(false);
      }
    };

    if (appsDropdownOpen || blogDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [appsDropdownOpen, blogDropdownOpen]);

  const closeMobileNav = () => {
    setMenuOpen(false);
    setAppsDropdownOpen(false);
    setBlogDropdownOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        <Link to="/" className="nav-logo" aria-label="WaveTech Home" onClick={closeMobileNav}>
          <img src="/wavetechoneletter.png" alt="WaveTech Logo" loading="lazy" />
        </Link>

        <button
          className={`menu-toggle ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          <li>
            <Link
              to="/services"
              className={isActive("/services") ? "nav-link active" : "nav-link"}
              onClick={closeMobileNav}
            >
              Services
            </Link>
          </li>

          <li
            className="nav-dropdown"
            ref={appsDropdownRef}
            onMouseEnter={() => !menuOpen && setAppsDropdownOpen(true)}
            onMouseLeave={() => !menuOpen && setAppsDropdownOpen(false)}
          >
            <button
              className="nav-dropdown-toggle"
              onClick={() => setAppsDropdownOpen(!appsDropdownOpen)}
              aria-expanded={appsDropdownOpen}
            >
              Apps
              <span className={`dropdown-arrow ${appsDropdownOpen ? "open" : ""}`}>▼</span>
            </button>
            <ul className={`dropdown-menu ${appsDropdownOpen ? "open" : ""}`}>
              <li>
                <Link
                  to="/wavenotify"
                  onClick={closeMobileNav}
                  className={isActive("/wavenotify") ? "dropdown-link active" : "dropdown-link"}
                >
                  Wave Notify
                </Link>
              </li>
              <li>
                <Link
                  to="/wavesync"
                  onClick={closeMobileNav}
                  className={isActive("/wavesync") ? "dropdown-link active" : "dropdown-link"}
                >
                  Wave Sync
                </Link>
              </li>
            </ul>
          </li>

          <li
            className="nav-dropdown"
            ref={blogDropdownRef}
            onMouseEnter={() => !menuOpen && setBlogDropdownOpen(true)}
            onMouseLeave={() => !menuOpen && setBlogDropdownOpen(false)}
          >
            <button
              className="nav-dropdown-toggle"
              onClick={() => setBlogDropdownOpen(!blogDropdownOpen)}
              aria-expanded={blogDropdownOpen}
            >
              Blog
              <span className={`dropdown-arrow ${blogDropdownOpen ? "open" : ""}`}>▼</span>
            </button>
            <ul className={`dropdown-menu ${blogDropdownOpen ? "open" : ""}`}>
              <li>
                <Link
                  to="/blog"
                  className="view-all-link"
                  onClick={closeMobileNav}
                >
                  View All Posts
                </Link>
              </li>
              <li className="dropdown-divider"></li>
              <li>
                <Link
                  to="/blog/best-shopify-apps"
                  onClick={closeMobileNav}
                  className="dropdown-link"
                >
                  Best Shopify Apps
                </Link>
              </li>
              <li>
                <Link
                  to="/blog/best-inventory-apps"
                  onClick={closeMobileNav}
                  className="dropdown-link"
                >
                  Best Inventory Apps
                </Link>
              </li>
              <li>
                <Link
                  to="/blog/how-to-sync-products"
                  onClick={closeMobileNav}
                  className="dropdown-link"
                >
                  How to Sync Products
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <Link
              to="/process"
              className={isActive("/process") ? "nav-link active" : "nav-link"}
              onClick={closeMobileNav}
            >
              Process
            </Link>
          </li>

          <li>
            <a
              href="https://support.wavetech.solutions/support"
              className="nav-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMobileNav}
            >
              Support
            </a>
          </li>

          <li className="nav-cta-wrapper">
            <Link
              to="/contact"
              className="nav-cta btn-primary"
              onClick={closeMobileNav}
            >
              Apply to Work With Us
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;